<template>
  <div class="row mb-3">
    <div class="col-5">{{ label }}</div>
    <div class="col-7">
      <b-form-checkbox
        :id="name"
        :checked="value"
        name="name"
        size="lg"
        @change="change"
      >
      </b-form-checkbox>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Checkbox',
  props: ['placeholder', 'label', 'name', 'value'],
  methods: {
    change(e) {
      this.$emit('input', e)
    },
  },
}
</script>

<style scoped>
.row {
  align-items: center;
  align-content: center;
}
</style>
